import {FormControl, Button, Grid, TableContainer, TableBody, TableCell, TableHead, TableRow, Paper, Table} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {useTranslation} from "react-i18next";
import React, {Fragment} from 'react';
import {observer} from 'mobx-react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_OBS} from './StatsCommon.js';
import {filterToMsg} from '../Main.js';
import StatsRow from './StatsRow.js';
import {COMM_OK} from '../WsR2.js';

const StatsObs = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const equals = ((a, b) => {
		return JSON.stringify(a) === JSON.stringify(b);
	})

	function objEquals(a, b) {
		const keys = Object.keys(a);

		if (keys.length !== Object.keys(b).length) 
			return false;

		return keys.every(k => equals(a[k], b[k]))
	}
  
	function arrayEquals(a, b) {
		return a.length === b.length && a.every((value, index) => objEquals(value, b[index]));

	}

	function obsAddLeftEnabled() {
		return gStorage.stats.obsList && gStorage.stats.obsList.length !== 0 &&
			(gStorage.stats.rightList.tab !== TAB_OBS || !arrayEquals(gStorage.stats.rightList.list, gStorage.stats.obsList));
	}

	function obsAddLeft() {
		gStorage.stats.setLeftList({...gStorage.stats.leftList, tab: TAB_OBS, list: gStorage.stats.obsList.slice()});
	}

	function obsAddRightEnabled() {
		return gStorage.stats.obsList && gStorage.stats.obsList.length !== 0 &&
			(gStorage.stats.leftList.tab !== TAB_OBS || !arrayEquals(gStorage.stats.leftList.list, gStorage.stats.obsList));
	}

	function obsAddRight() {
		gStorage.stats.setRightList({...gStorage.stats.rightList, tab: TAB_OBS, list: gStorage.stats.obsList.slice()});
	}

	function obsListRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('obsListRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('obsListRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_OBS)
			return;

// 		console.log('obsListRxWs', msg);
		gStorage.stats.setObsList(msg.data.list);
	}

	function loadObsList() {
		let city_arr = [], spec_arr = [], trip_arr = [], asso_arr = [];
		let dt = new Date();
		let tz = -dt.getTimezoneOffset() * 60;

		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'obs',
			op: 'stats',
			data: {
				city: city_arr,
				species: spec_arr,
				trips: trip_arr,
				asso: asso_arr,
				tz: tz,
				coordinates: [],
			},
		}

		filterToMsg(gStorage.main.filter, msg, gStorage.conn.user.id, gStorage.lists.speclist.list);

// 		console.log('loadObsList', msg);
		gStorage.conn.ws.send(msg, obsListRxWs);
	}

	function obsSrc() {
		let prev_y = -1, i;
		let ret = [];

		if (!gStorage.stats.obsList || gStorage.stats.obsList.length <= 0 || !gStorage.stats.obsList[0].spec_id || gStorage.stats.tab !== TAB_OBS)
			return null;

		let ol = gStorage.stats.obsList.length;

		for (i = ol - 1; i >= 0 ; i--) {
			let obs = gStorage.stats.obsList[i], bg;
			const y = new Date(obs.start_t * 1000.0).getYear();

			if (y !== prev_y) {
				let j, n;

				n = 1;

				for (j = i - 1; j >= 0; j--) {
					let obs2 = gStorage.stats.obsList[j];
					const y2 = new Date(obs2.start_t * 1000.0).getYear();

					if (y2 !== y) 
						break;

					n++;
				}

				if (prev_y !== -1)
					ret.push(<TableRow key={-y * 2 - 1}><TableCell colSpan={4}>&nbsp;</TableCell></TableRow>);

				ret.push(<TableRow key={-y * 2} style={{backgroundColor: '#f0f0f0'}}><TableCell colSpan={4}>{(y + 1900) + ' ' + n + ' ' + t('stats.species')}</TableCell></TableRow>);
			}

			bg =  obs.lifer === 1 ? '#cbffe2' : '#ffffff';

			ret.push(
				<StatsRow
					key	= {i + 1}
					bgcolor	= {bg}
					row_n	= {i + 1}
					obs	= {obs}
				/>);

			prev_y = y;
		}

		return ret;
	}

	if (gStorage.stats.tab !== TAB_OBS) 
		return null;

	if (!gStorage.stats.obsList && gStorage.conn.online) 
		loadObsList();

	return (
		<Fragment>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
				<Grid>
					<FormControl>
						<div>
							<Button 
							disabled={!obsAddLeftEnabled()} 
							onClick={obsAddLeft}>
								L&nbsp;
								<AddCircleOutlineIcon/>
							</Button>
							&nbsp;&nbsp;&nbsp;&nbsp;
							<Button 
							disabled={!obsAddRightEnabled()} 
							onClick={obsAddRight}>
								<AddCircleOutlineIcon/>
								&nbsp;R
							</Button>
						</div>
					</FormControl>
				</Grid>
			</Grid>
			<TableContainer component={Paper} elevation={0}>
				<Table size='small'>
					<TableHead>
						<TableRow>
							<TableCell>#</TableCell>
							<TableCell>{t('main.species')}</TableCell>
							<TableCell>{t('main.time')}</TableCell>
							<TableCell>{t('main.location')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{obsSrc()}
					</TableBody>
				</Table>
			</TableContainer>
		</Fragment>
	);

});

export default StatsObs;
